"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesLinksTypeGroupSchema = void 0;
exports.ServicesLinksTypeGroupSchema = {
    "$id": "https://www.redbull.com/schemas/type-groups/services/links.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ServicesLinksTypeGroup",
    "description": "ServicesLinksTypeGroup represents one of the following types: FacebookFollow, InstagramFollow, Snapchat, SoundcloudSocialLink, SpotifySocialLink, ThingImage, TikTokSocialLink, TwitchSocialLink, YoutubeSocialLink",
    "oneOf": [
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/facebook-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/instagram-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/snapchat-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/soundcloud-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/spotify-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/thing-link/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/tiktok-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitch-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/youtube-sociallink/1.schema.json"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGlua3Muc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL21vZHVsZXMvdHlwZS1ncm91cHMvc2VydmljZXMvbGlua3Muc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsNEJBQTRCLEdBQUc7SUFDMUMsS0FBSyxFQUFFLHdFQUF3RTtJQUMvRSxTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSx3QkFBd0I7SUFDakMsYUFBYSxFQUFFLHFOQUFxTjtJQUNwTyxPQUFPLEVBQUU7UUFDUDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSx3RkFBd0Y7U0FDakc7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSx5RkFBeUY7U0FDbEc7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSx3RkFBd0Y7U0FDakc7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSwwRkFBMEY7U0FDbkc7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSx1RkFBdUY7U0FDaEc7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSwrRUFBK0U7U0FDeEY7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxzRkFBc0Y7U0FDL0Y7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxzRkFBc0Y7U0FDL0Y7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSx1RkFBdUY7U0FDaEc7S0FDRjtDQUNGLENBQUEifQ==